var map = {
	"./begin.html": "5f0c",
	"./card-1.html": "dc96",
	"./card-10.html": "4bb6",
	"./card-11.html": "b7ae",
	"./card-12.html": "187e",
	"./card-2.html": "c727",
	"./card-3.html": "912c",
	"./card-4.html": "9fa2",
	"./card-5.html": "2568",
	"./card-6.html": "9b24",
	"./card-7.html": "ab0b",
	"./card-8.html": "b7de",
	"./card-9.html": "37b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c82d";